import { AxiosResponse } from 'axios';
import EnrouteApiClient from '../../shared/services/enroute-api-client';
import {
  BulkUploadTaskContainer, BulkUploadTaskUpdate,
  JobsUploadStatus,
  JobsUploadStatusWithErrors,
} from '../../shared/models/jobs';
import { ServerError, ServerErrorMessages } from "../../shared/utils/server-error-utils";

export default class UploadService {

  public static async getAllUploads(): Promise<JobsUploadStatus[] | Error> {
    return EnrouteApiClient.get('/bulk-upload/uploads')
      .then((resp: AxiosResponse<JobsUploadStatus[]>) => resp.data)
      .catch(error => {
        let errorMessage = ServerErrorMessages[error.message];
        if (!errorMessage) {
          errorMessage = ServerErrorMessages[ServerError.UnexpectedError];
        }

        throw new Error(errorMessage);
      });
  }

  public static async upload(file: File): Promise<JobsUploadStatus | Error> {
    const formData = new FormData();
    formData.append('file', file);

    return EnrouteApiClient.post('/bulk-upload/uploads', formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((resp: AxiosResponse<JobsUploadStatus>) => resp.data);
  }

  public static async export(ids: number[]): Promise<void> {
    return EnrouteApiClient.get('/bulk-upload/export', {
      responseType: 'blob',
      params: {
        ids: ids.join(','),
      },
    }).then((resp: AxiosResponse<Blob>) => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'export.csv');
      document.body.appendChild(link);
      link.click();
    });
  }

  public static async getUploadStatus(id: string): Promise<JobsUploadStatusWithErrors | Error> {
    return EnrouteApiClient.get(`/bulk-upload/jobs/${ id }`)
      .then((resp: AxiosResponse<JobsUploadStatusWithErrors>) => resp.data);
  }

  public static async getTasks(uploadID: string): Promise<BulkUploadTaskContainer[]> {
    const response = await EnrouteApiClient.get(`/bulk-upload/uploads/${ uploadID }/tasks`);

    return response.data;
  }

  public static async updateTask(uploadID: string, taskID: string, payload: BulkUploadTaskUpdate): Promise<BulkUploadTaskContainer> {
    const response = await EnrouteApiClient.post(`/bulk-upload/uploads/${ uploadID }/tasks/${ taskID }`, payload);

    return response.data;
  }

  public static async processUpload(uploadID: string): Promise<JobsUploadStatus> {
    const response = await EnrouteApiClient.post(`/bulk-upload/uploads/${ uploadID }/process`);

    return response.data;
  }
}